<template>
	<v-container fluid>
		<v-row justify="center">
			<v-col cols="5" sm="3" md="2" class="m-2">
				<v-btn :href="landingUrl" small color="primary">ir a Kronogram.cl</v-btn>
			</v-col>
		</v-row>
		<v-row justify="center" align="center" no-gutters style="height: 90vh; overflow: auto;">
			<v-col cols="12" sm="8" md="7" lg="5" xl="4">
				<img width="300" class="mx-auto" contain src="@/assets/lusazu_logo.png" />
				<v-window v-model="step">
					<v-window-item :value="1">
						<v-form @submit.prevent="onSubmit" class="auth-class mb-5 px-5 py-5">
							<v-text-field
								id="email-input"
								v-model.trim="loginData.email"
								label="Correo electrónico o rut"
								name="login"
								prepend-icon="mdi-account"
								dense
								filled
								outlined
								type="text"
								required
							/>
							<v-text-field
								id="password-input"
								v-model.trim="loginData.password"
								:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
								label="Contraseña"
								name="password"
								prepend-icon="mdi-lock"
								dense
								filled
								outlined
								:type="showPassword ? 'text' : 'password'"
								required
								@click:append="showPassword = !showPassword"
							/>
							<v-btn
								block
								:disabled="!(loginData.email && loginData.password)"
								:loading="loading"
								rounded
								small
								color="primary"
								type="submit"
								data-cy="loginButton"
							>
								Ingresar
							</v-btn>
							<v-spacer />
							<GoogleButton class="my-3" />
							<v-spacer />
							<v-btn block text x-small color="primary" @click="step = 2">
								¿Olvidaste tu contraseña?
							</v-btn>
						</v-form>
					</v-window-item>
					<v-window-item :value="2">
						<password-recover :back="() => (step = 1)" />
					</v-window-item>
					<v-window-item :value="3">
						<register />
					</v-window-item>
				</v-window>
				<v-btn
					v-if="step === 1"
					color="success"
					dark
					@click="step = 3"
					data-cy="registerButton"
				>
					Registrarme
				</v-btn>
				<v-btn v-if="step === 3" color="primary" small @click="step = 1">
					¿Tienes cuenta? Ingresa ya
				</v-btn>
			</v-col>
		</v-row>
		<v-dialog v-model="dialogfechaDeCorte" width="300" persistent>
			<v-card>
				<div class="text-center pa-4">
					{{
						cuentaDesactivada
							? 'Su cuenta esta desactivada por pago pendiente'
							: 'Su cuenta tiene un pago pendiente'
					}}
					<br />
					<v-btn class="my-4" depressed tile color="primary" @click="salir">
						Ir pagos
					</v-btn>
				</div>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
import { landing } from '@/config';
import GoogleButton from '@/components/auth/GoogleButton';
import { loginWith, logout } from '@/plugins/auth';
import { mapMutations } from 'vuex';

export default {
	name: 'Auth',
	layout: 'simple',
	components: {
		PasswordRecover: () => import('@/components/auth/PasswordRecover'),
		Register: () => import('@/components/auth/Register'),
		GoogleButton,
	},
	data() {
		return {
			dialogfechaDeCorte: false,
			cuentaDesactivada: false,
			loading: false,
			showPassword: false,
			loginData: {
				email: '',
				password: '',
			},
			passwordRecover: false,
			step: 1,
		};
	},
	computed: {
		landingUrl() {
			return landing;
		},
	},
	created() {
		this.$vuetify.theme.dark = false;
	},
	methods: {
		async onSubmit() {
			try {
				this.loading = !this.loading;
				const data = await loginWith('local', this.loginData);
				this.loading = false;
				if (
					data.user.role === 'admin' &&
					data.verificacionDePago &&
					data.verificacionDePago.desactivar
				) {
					await logout();
					this.dialogfechaDeCorte = true;
					this.cuentaDesactivada = true;
					return;
				} else if (
					data.user.role === 'admin' &&
					data.verificacionDePago &&
					data.verificacionDePago.warning
				) {
					this.dialogfechaDeCorte = true;
					return;
				}
				this.afterLogin();
			} catch (error) {
				this.loading = false;
				this.snackbar({
					content: 'Usuario o contraseña incorrectos',
					color: 'error',
				});
			}
		},
		async salir() {
			this.dialogfechaDeCorte = false;
			if (this.cuentaDesactivada) {
				await logout();
				this.cuentaDesactivada = false;
			} else {
				this.afterLogin();
			}
			const a = document.createElement('a');
			a.target = '_blank';
			a.href = 'https://certplag.cl/servicios/pagos';
			a.click();
		},
		afterLogin() {
			const roleRoutes = {
				admin: { name: 'inicio' },
				superUser: { name: 'inicio' },
				person: { path: '/guest/timeline' },
			};
			const route = roleRoutes[this.userProfile.role];
			if (route) {
				this.$router.push(route);
			}
		},
		...mapMutations({
			snackbar: 'Snackbar/showMessage',
		}),
	},
};
</script>

<style lang="scss">
.auth-class {
	background-color: #ffffff8c !important;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
	transition: background-color 5000s ease-in-out 0s;
}
</style>
